import useSWR from "swr";

import SWR_KEYS from "@/constants/swr-keys";
import { AccountAnticipationConfiguration } from "@/interfaces/talk2pay.iterfaces";
import t2payService from "@/services/t2pay.service";
import { RequestsBaseReturn } from "@/types/requests.types";

export type UseGetAccountAnticipationReturn =
  RequestsBaseReturn<AccountAnticipationConfiguration | null>;

const useGetAccountAnticipation = (): UseGetAccountAnticipationReturn => {
  const {
    data = null,
    isValidating: isLoading,
    error,
  } = useSWR<AccountAnticipationConfiguration, Error>(
    SWR_KEYS.getAccountAnticipation,
    () => t2payService.getAccountAnticipation(),
    {
      revalidateOnFocus: false,
    }
  );

  return { data, isLoading, error };
};

export default useGetAccountAnticipation;
